import React, { FC } from 'react'
import FormHelperText from '@mui/material/FormHelperText'
import FormControl from '@mui/material/FormControl'

import HelperText from '@kaidam/fc-shared/src/frontend/components/form/fields/HelperText'
import { getProps } from '@kaidam/fc-shared/src/frontend/components/form/fields/utils'

import TagEditor from '../../tag/TagEditor'

import {
  FormFieldProps,
} from '../../../types/form'

const TagEditorField: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {

  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    error,
    disabled,
    touched,
    item,
  } = getProps(props)
  
  const title = item.title || name

  return (
    <FormControl component="fieldset">
      <FormHelperText>{ title }</FormHelperText>
      <TagEditor
        tags={ item.meta?.tags || [] }
        value={ value }
        readOnly={ disabled }
        onChange={ (newValue) => setFieldValue(name, newValue) }
      />
      <HelperText
        helperText={ item.helperText }
        error={ error ? true : false }
        touched={ touched }
      />
    </FormControl>
  )
}

export default TagEditorField